/* Copyright (c) 2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { Button, ModalConfirm } from "@nordcloud/gnui";
import { useShowError } from "~/components/Error/useShowError";
import { showSuccess } from "~/components/Toast";
import { useCustomer } from "~/context/User/Customer";
import { CustomerService } from "~/models";
import {
  generateActionConfirmText,
  generateActionSuccessText,
  useAxios,
} from "~/tools";

type Props = {
  service: CustomerService;
  refetch: () => Promise<void>;
};

export default function ({ service, refetch }: Props) {
  const [isOpen, setIsOpen] = React.useState(false);
  const { showError } = useShowError();
  const { Axios } = useAxios();
  const { customer } = useCustomer();

  const unassignService = async () => {
    try {
      await Axios().delete(
        `/customers/${customer.id}/service-offering/${service.id}`
      );
      refetch();
      showSuccess(
        generateActionSuccessText(`Service ${service.name}`)()("unassigned")()
      );
    } catch (e) {
      showError(e.response);
    }
    setIsOpen(false);
  };

  return (
    <>
      <Button
        onClick={() => setIsOpen(true)}
        size="sm"
        severity="low"
        icon="brokenLink"
      >
        Unassign service
      </Button>

      <ModalConfirm
        onClose={() => setIsOpen(false)}
        isOpen={isOpen}
        confirm={unassignService}
        actionLabel="Unassign"
        contentLabel="Unassign Service"
      >
        {generateActionConfirmText(`service ${service.name}`)("unassign")()}
      </ModalConfirm>
    </>
  );
}
